import * as React from 'react';
import { StyledMenuItem, StyledMenuItemLink, MenuItemBadge } from './styles';
import { Dispatch } from 'redux';
import { MenuItem, MenuItemType } from '../../../../typings/menu';
import { StoreState } from '../../../../reducers';
import { MenuActionKeys, openCustomItem } from '../../../../containers/MenuManager/actions';
import Utils from '../../../../utils';
import RoutesUtils from '../../../../utils/routes';
import { signOut } from '../../../../containers/MultiAppAuthentication/actions';
import { disconnect } from '../../../../containers/Authentication/actions';
import { toggleSearchFieldVisibility } from '../../../../containers/DriveItemList/Search/actions';

const I18n = require('react-redux-i18n').I18n;
// Make i18n return the whole key in case of a missing translation and not only the last item.
const HandleMissingTranslation = (key) => key;
I18n.setHandleMissingTranslation(HandleMissingTranslation);

export interface LeftMenuItemProps {
	menuItem: MenuItem;
	badge?: number;
	isActive: boolean;
	isRoute: boolean;
	isMultiApp: boolean;
	dispatch: Dispatch<StoreState>;
}

class LeftMenuItem extends React.Component<LeftMenuItemProps, {}> {

	constructor(props: LeftMenuItemProps) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		const { isMultiApp, isRoute, menuItem, dispatch } = this.props;
		const { type, target } = menuItem;

		if (type === MenuItemType.LogOut) {
			if (isMultiApp) {
				dispatch(signOut());
			} else {
				dispatch(disconnect());
			}
		} else if (type === MenuItemType.SearchButton) {
			dispatch(toggleSearchFieldVisibility());
		} else if (type === MenuItemType.CookieSettings) {
			window.tarteaucitron.userInterface.openPanel();
		} else if (isRoute) {
			RoutesUtils.historyPush(target);
		} else {
			dispatch(openCustomItem(type, target));
		}

		dispatch({ type: MenuActionKeys.REQUEST_CLOSE_LEFT_MENU });
	}

	render() {
		const { menuItem, badge, isActive } = this.props;
		const { icon } = menuItem;

		return (
			<StyledMenuItem
				onClick={this.handleClick}
				isActive={isActive}
				className={`menu-item ${menuItem.type}`}
			>
				<StyledMenuItemLink>
					{Utils.getSvgIcon(icon)}
					{I18n.t(menuItem.label)}
					{!!badge && <MenuItemBadge>{badge}</MenuItemBadge>}
				</StyledMenuItemLink>
			</StyledMenuItem>
		);
	}
}

export default LeftMenuItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Left/MenuItem/index.tsx